webpackJsonp([0],{

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__(199);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632f88d5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(209);
function injectStyle (ssrContext) {
  __webpack_require__(207)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-632f88d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632f88d5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Loading',
  data: function data() {
    return {
      isEdge: false
    };
  },
  created: function created() {
    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    this.isEdge = !isIE && !!window.StyleMedia;
  }
});

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(208);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("22e1ecb7", content, true, {});

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".vlt-loading[data-v-632f88d5]{text-align:center}.vlt-loading img[data-v-632f88d5]{width:24px}.alternateLoader[data-v-632f88d5]{border:2px solid #f3f3f3;border-radius:50%;border-top:2px solid #5a5a5a;border-right:2px solid #5a5a5a;border-bottom:2px solid #5a5a5a;width:20px;height:20px;-webkit-animation:spin-data-v-632f88d5 .5s linear infinite;animation:spin-data-v-632f88d5 .5s linear infinite;margin:0 auto}@-webkit-keyframes spin-data-v-632f88d5{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}@keyframes spin-data-v-632f88d5{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Templates/Loading.vue"],"names":[],"mappings":"AACA,8BAA8B,iBAAiB,CAC9C,AACD,kCAAkC,UAAU,CAC3C,AACD,kCAAkC,yBAAyB,kBAAkB,6BAA6B,+BAA+B,gCAAgC,WAAW,YAAY,2DAA2D,mDAAmD,aAAa,CAC1T,AACD,wCACA,GAAG,8BAA8B,CAChC,AACD,GAAK,+BAAgC,CACpC,CACA,AACD,gCACA,GAAG,+BAA+B,sBAAsB,CACvD,AACD,GAAK,gCAAiC,uBAAwB,CAC7D,CACA","file":"Loading.vue","sourcesContent":["\n.vlt-loading[data-v-632f88d5]{text-align:center\n}\n.vlt-loading img[data-v-632f88d5]{width:24px\n}\n.alternateLoader[data-v-632f88d5]{border:2px solid #f3f3f3;border-radius:50%;border-top:2px solid #5a5a5a;border-right:2px solid #5a5a5a;border-bottom:2px solid #5a5a5a;width:20px;height:20px;-webkit-animation:spin-data-v-632f88d5 .5s linear infinite;animation:spin-data-v-632f88d5 .5s linear infinite;margin:0 auto\n}\n@-webkit-keyframes spin-data-v-632f88d5{\n0%{-webkit-transform:rotate(0deg)\n}\n100%{-webkit-transform:rotate(360deg)\n}\n}\n@keyframes spin-data-v-632f88d5{\n0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)\n}\n100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vlt-loading"},[(!_vm.isEdge)?_c('img',{staticClass:"loading-ico",attrs:{"src":__webpack_require__(210),"alt":"loader"}}):_c('div',{staticClass:"alternateLoader"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCIgY2xhc3M9Imxkcy1yb2xsaW5nIj48Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiBmaWxsPSJub25lIiBuZy1hdHRyLXN0cm9rZT0ie3tjb25maWcuY29sb3J9fSIgbmctYXR0ci1zdHJva2Utd2lkdGg9Int7Y29uZmlnLndpZHRofX0iIG5nLWF0dHItcj0ie3tjb25maWcucmFkaXVzfX0iIG5nLWF0dHItc3Ryb2tlLWRhc2hhcnJheT0ie3tjb25maWcuZGFzaGFycmF5fX0iIHN0cm9rZT0iIzVhNWE1YSIgc3Ryb2tlLXdpZHRoPSIxMCIgcj0iMzUiIHN0cm9rZS1kYXNoYXJyYXk9IjE2NC45MzM2MTQzMTM0NjQxNSA1Ni45Nzc4NzE0Mzc4MjEzOCIgdHJhbnNmb3JtPSJyb3RhdGUoMjUyIDUwIDUwKSI+PGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGNhbGNNb2RlPSJsaW5lYXIiIHZhbHVlcz0iMCA1MCA1MDszNjAgNTAgNTAiIGtleVRpbWVzPSIwOzEiIGR1cj0iMC41cyIgYmVnaW49IjBzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSI+PC9hbmltYXRlVHJhbnNmb3JtPjwvY2lyY2xlPjwvc3ZnPgo="

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.3893f64494a90750dc4b.js